import script from "./CityArmyPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CityArmyPanel.vue?vue&type=script&setup=true&lang=js"

import "./CityArmyPanel.vue?vue&type=style&index=0&id=4b4e59b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b4e59b0"]])

export default __exports__